export default "__VITE_ASSET__TqBiosfO__"